export default "__VITE_ASSET__sRvJ53fi__"